export default [
    {
        label: 'Priorität',
        key: 'priority',
        param: {},
    },
    {
        label: 'Wahrscheinlichkeit',
        key: 'probability',
        param: {},
    },
    {
        label: 'Startdatum',
        key: 'createdAt',
        param: {},
    },
    {
        label: 'Enddatum',
        key: 'endDate',
        param: {},
    },
    {
        label: 'Bestand',
        key: 'inStock',
        param: {},
    },
    {
        label: 'Gewonnen',
        key: 'totalWins',
        param: {},
    },
    {
        label: 'Verloren',
        key: 'totalLoses',
        param: {},
    },

    {
        label: 'Laufzeit',
        key: 'lifetime',
        param: {},
    },
];
